<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="height:auto;min-height:50px;padding:8px 10px;background:linear-gradient(to right,#fff,var(--border));flex-wrap:wrap;gap:8px;">
      <div class="flex-wrap split5" style="align-items:center;flex-wrap:wrap;">
        <Select
          v-model="project_id"
          filterable
          clearable
          style="width:min(360px, 92vw)"
          placeholder="选择项目"
          @on-change="onProjectChange"
        >
          <Option
            v-for="pr in projects"
            :key="pr.id"
            :value="pr.id"
            :label="projectOptionLabel(pr)"
          >
            <span>{{ pr.name || pr.shortname || pr.id }}</span>
            <Tag v-if="pr.code">{{ pr.code }}</Tag>
            <Tag v-if="pr.status">{{ pr.status }}</Tag>
          </Option>
        </Select>
        <Button
          size="small"
          icon="md-refresh"
          :disabled="!project_id"
          :loading="dataLoading"
          @click="fetchProjectDetail"
        >
          刷新数据
        </Button>
        <a
          class="ivu-btn ivu-btn-text"
          :href="contractsAdminHref"
          target="_blank"
          rel="noopener"
        >前往合约系统</a>
      </div>
      <div class="zzl-view-top-actions flex-wrap" style="gap:8px;">
        <Button class="zzl-view-top-refresh" type="default" :loading="listLoading" @click="loadProjectList">刷新项目列表</Button>
      </div>
    </div>

    <div class="flex-wrap" style="padding:6px 10px;border-bottom:1px solid var(--border);flex-wrap:wrap;gap:8px;align-items:center;background:var(--bg3);">
      <span style="font-size:12px;color:var(--subtext2);">数据板块（按需勾选，文本按固定顺序生成）：</span>
      <CheckboxGroup v-model="selectedSections" @on-change="onSectionsChange">
        <Checkbox v-for="s in sectionDefs" :key="s.key" :label="s.key">{{ s.label }}</Checkbox>
      </CheckboxGroup>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="dataLoading" fix size="large">
          <div class="zzl-view-data-loading-text">加载项目详情中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;flex-wrap:wrap;gap:8px;">
            <div class="zzl-view-section-title" style="margin:0;">数据整理</div>
            <div class="flex-wrap" style="align-items:center;flex-wrap:wrap;gap:8px;justify-content:flex-end;">
              <span style="font-size:12px;color:var(--subtext2);">字符数 {{ aiText.length }}</span>
              <Button @click="copyRawData" type="info" :disabled="!aiText">复制文本</Button>
              <Button @click="downloadRawData" :disabled="!aiText">下载 .txt</Button>
            </div>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              v-model="aiText"
              :rows="6"
              class="zzl-view-fill-textarea"
              style="width:100%;flex:1;min-height:0;"
              placeholder="请选择项目后将自动加载数据。文本根据勾选板块从接口数据清洗生成，供提示词 + 大模型分析。"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              mod="cm-project-detail"
              :textarea-rows="5"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod('cm-project-detail') }} · cm-project-detail）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;flex-wrap:wrap;gap:8px;">
          <div class="zzl-view-section-title" style="margin:0;">分析报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button
              type="primary"
              icon="md-play"
              :loading="ai_executings"
              :disabled="aiText.length < 10"
              @click="CreateByAI"
            >
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
            <AiSaveToKnowledgeButton :content="result" :disabled="!result || ai_executings" :file-name="zzlSaveFileName" />
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';
import { buildZzlPdfFileStem } from '@/components/ai/zzl/zzl-report-filename';
import {
  buildCmProjectDetailText,
  CM_PROJECT_DETAIL_SECTIONS,
  orderSectionKeys,
} from '@/components/ai/cm/cm-project-detail-text';

moment.locale('zh-cn');

const DEFAULT_ANALYSIS_PROMPT = `你是一名建设工程咨询与合同管理顾问。下面「项目数据」来自公司内部项目管理系统（已整理为结构化文本）。请结合数据输出一份简明、可执行的分析，建议包括：
1. 项目概况与当前阶段判断
2. 进度与计划匹配度（如有延误指出可能方向，勿臆测未记载原因）
3. 人员投入与岗位匹配简评
4. 收费/开票/到账情况与现金流相关风险提示
5. 建安工程量变化趋势（若有该板块数据）
6. 重要事项与风险提示汇总

要求：用中文分条论述，必要时给可执行建议清单；不要编造数据中未出现的事实；金额与日期与原文保持一致。`;

export default {
  routerOption: {
    as_default: true,
  },
  components: {AiPromptPanel, AiMarkdownStreamPanel},
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    return {
      pageStateFields: ['project_id', 'selectedSections', 'userText'],
      sectionDefs: CM_PROJECT_DETAIL_SECTIONS,
      selectedSections: CM_PROJECT_DETAIL_SECTIONS.map((s) => s.key),
      projects: [],
      project_id: '',
      rawProject: null,
      aiText: '',
      userText: DEFAULT_ANALYSIS_PROMPT,
      dataLoading: false,
      listLoading: false,
      ai_executings: false,
      result: '',
    };
  },
  computed: {
    contractsAdminHref() {
      try {
        return this.$router.resolve({path: `/core/projects/${this.project_id}/cm`}).href;
      } catch (e) {
        return '#';
      }
    },
  },
  mounted() {
    this.$api.afterLogin(() => {
      this.loadProjectList();
    });
  },
  methods: {
    labelForMod,
    projectOptionLabel(pr) {
      const name = pr.name || pr.shortname || pr.id;
      return pr.code ? `${name} (${pr.code})` : name;
    },
    onProjectChange(val) {
      this.rawProject = null;
      this.aiText = '';
      this.result = '';
      if (val) {
        this.fetchProjectDetail();
      }
      this.__savePageState();
    },
    onSectionsChange() {
      this.normalizeSelectedSections();
      if (this.rawProject) {
        this.rebuildText();
      } else {
        this.__savePageState();
      }
    },
    normalizeSelectedSections() {
      this.selectedSections = orderSectionKeys(this.selectedSections);
    },
    __afterRestorePageState() {
      this.normalizeSelectedSections();
      if (this.project_id) {
        this.$nextTick(() => this.fetchProjectDetail());
      }
    },
    normalizeSimpleList(d) {
      if (Array.isArray(d)) {
        return d;
      }
      if (d && Array.isArray(d.list)) {
        return d.list;
      }
      if (d && Array.isArray(d.rows)) {
        return d.rows;
      }
      if (d && Array.isArray(d.data)) {
        return d.data;
      }
      return [];
    },
    loadProjectList() {
      this.listLoading = true;
      this.$api.get('cm/projects?q=simple')
          .then((res) => {
            this.projects = this.normalizeSimpleList(res.data.data);
          })
          .catch((e) => {
            console.error(e);
            this.Error(e && e.message ? e.message : '加载项目列表失败');
          })
          .finally(() => {
            this.listLoading = false;
          });
    },
    fetchProjectDetail() {
      if (!this.project_id) {
        this.Error('请先选择项目');
        return;
      }
      this.dataLoading = true;
      this.$api.get(`/projects/${this.project_id}?q=cm`)
          .then((res) => {
            const project = res.data.data;
            if (!project || typeof project !== 'object') {
              this.Error('接口未返回项目数据');
              return;
            }
            if (Array.isArray(project.condition_groups) && Array.isArray(project.conditions)) {
              project.condition_groups.forEach((g) => {
                g.conditions = project.conditions.filter((c) => c.business_type === g.business_type);
              });
            }
            this.rawProject = project;
            this.rebuildText();
          })
          .catch((e) => {
            console.error(e);
            this.Error(e && e.message ? e.message : '获取项目详情失败');
          })
          .finally(() => {
            this.dataLoading = false;
          });
    },
    rebuildText() {
      if (!this.rawProject) {
        return;
      }
      this.normalizeSelectedSections();
      this.aiText = buildCmProjectDetailText(this.rawProject, this.selectedSections);
      this.__savePageState();
    },
    zzlReportPdfStem() {
      const name = (this.rawProject && this.rawProject.name)
        ? String(this.rawProject.name)
        : (this.project_id || 'export');
      return buildZzlPdfFileStem(['合约分析', name]);
    },
    exportTxtStem() {
      const name = (this.rawProject && this.rawProject.name) ? String(this.rawProject.name) : (this.project_id || 'export');
      return `${name.replace(/[/\\?%*:|"<>]/g, '_')}_项目详情_${moment().format('YYYYMMDD_HHmm')}`;
    },
    copyRawData() {
      if (!this.aiText) {
        return;
      }
      this._zzlCopyText(this.aiText, '已复制项目文本');
    },
    downloadRawData() {
      if (!this.aiText) {
        return;
      }
      const blob = new Blob([this.aiText], {type: 'text/plain;charset=utf-8'});
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `${this.exportTxtStem()}.txt`;
      a.click();
      URL.revokeObjectURL(a.href);
      this.Success('已开始下载');
    },
  },
};
</script>
